import React, { useState, useEffect } from 'react';
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  FormControl,
  FormLabel,
  Input,
  HStack,
  IconButton,
  Button,
  useToast,
} from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { FaPlus } from 'react-icons/fa';

interface UsuarioTableProps {
  onOpenDetail: (id: string | null) => void;
}

const UsuarioTable: React.FC<UsuarioTableProps> = ({ onOpenDetail }) => {
  const [usuarios, setUsuarios] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const toast = useToast();

  const fetchUsuarios = async () => {
    try {
      const response = await fetch(
        `http://52.91.130.91:5000/api/usuarios?page=${page}&pageSize=${pageSize}&search=${searchQuery}`
      );
      const data = await response.json();
      setUsuarios(data.data);
      setTotalPages(data.pagination.totalPages);
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudieron cargar los usuarios.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    fetchUsuarios();
  }, [page, searchQuery]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  return (
    <Box p={8} bg="gray.50" borderRadius="md" boxShadow="md" maxW="1200px" mx="auto" mt={8}>
      <Heading as="h1" size="lg" color="teal.500" mb={6} textAlign="center">
        Usuarios - Gestión
      </Heading>

      <FormControl id="search" mb={4}>
        
        <HStack>
          <Input placeholder="Buscar..." value={searchQuery} onChange={handleSearch} />
          <Button colorScheme="teal" leftIcon={<FaPlus />} onClick={() => onOpenDetail(null)}>
            Nuevo Usuario
          </Button>
        </HStack>
      </FormControl>

      <Box overflowX="auto">
        <Table variant="simple" size="md">
          <Thead>
            <Tr>
              <Th>ID</Th>
              <Th>Nombre</Th>
              <Th>Primer Apellido</Th>
              <Th>Segundo Apellido</Th>
              <Th>Usuario</Th>
              <Th>Email</Th>
              <Th>Activo</Th>
            </Tr>
          </Thead>
          <Tbody>
            {usuarios.map((usuario: any) => (
              <Tr
                key={usuario.id}
                onClick={() => onOpenDetail(usuario.id)}
                style={{ cursor: 'pointer' }}
              >
                <Td>{usuario.id}</Td>
                <Td>{usuario.nombre}</Td>
                <Td>{usuario.primerApellido}</Td>
                <Td>{usuario.segundoApellido}</Td>
                <Td>{usuario.usuario}</Td>
                <Td>{usuario.email}</Td>
                <Td>{usuario.activo ? 'Sí' : 'No'}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      <HStack spacing={4} mt={4} justifyContent="center">
        <IconButton
          icon={<ChevronLeftIcon />}
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          isDisabled={page === 1}
          aria-label="Página anterior"
        />
        <Box>Página {page} de {totalPages}</Box>
        <IconButton
          icon={<ChevronRightIcon />}
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          isDisabled={page === totalPages}
          aria-label="Página siguiente"
        />
      </HStack>
    </Box>
  );
};

export default UsuarioTable;
